






























































import { Component, Vue } from "vue-property-decorator";
import CandidatePortalLogo from "./CandidatePortalLogo.vue";
import { vxm } from "./../store.vuex";

@Component({
  name: "Banner",
  components: {
    CandidatePortalLogo
  }
})
export default class Banner extends Vue {
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isAppWebView() {
    return vxm.utility.AppWebView;
  }
}
